import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { useNavigate } from 'react-router-dom';
import { colors, shared } from '../styles/theme';

function Careers() {
  const navigate = useNavigate();

  return (
    <section className={css(styles.section)}>
      <button className={css(styles.backButton)} onClick={() => navigate('/')}>
        Back
      </button>

      <div className={css(styles.card)}>
        <span className={css(styles.badge)}>Now recruiting</span>
        <h1 className={css(styles.title)}>Waiter / Delivery Rider</h1>
        <p className={css(styles.description)}>
          Fortress Restaurant is looking for a motivated and customer-focused
          waiter. Applicants with scooter or motorcycle riding experience will
          have an added advantage as they may assist with YaBatho delivery
          orders when required.
        </p>

        <div className={css(styles.grid)}>
          <div className={css(styles.panel)}>
            <h2 className={css(styles.panelTitle)}>Requirements</h2>
            <ul className={css(styles.list)}>
              <li>Previous waiter experience is an advantage</li>
              <li>Motorcycle or scooter riding experience is an advantage</li>
              <li>Valid driver's licence is an advantage</li>
              <li>Good customer service skills</li>
              <li>Reliable and professional</li>
              <li>Able to work flexible shifts</li>
            </ul>
          </div>

          <div className={css(styles.panel)}>
            <h2 className={css(styles.panelTitle)}>Benefits</h2>
            <ul className={css(styles.list)}>
              <li>Restaurant waiter position</li>
              <li>Additional delivery earning opportunities</li>
              <li>Growth within Fortress Restaurant and YaBatho</li>
            </ul>
          </div>
        </div>

        <div className={css(styles.location)}>
          <h2 className={css(styles.panelTitle)}>Location</h2>
          <p className={css(styles.locationText)}>
            194 Bancor Avenue, Ext 2 Menlyn Maine Central Square, Shop No. 103,
            Pretoria East, South Africa, 0181
          </p>
        </div>

        <button
          className={css(styles.applyButton)}
          onClick={() => {
            window.location.href = 'mailto:careers@yabathoplatform.co.za';
          }}
        >
          Apply Now
        </button>
      </div>
    </section>
  );
}

const styles = StyleSheet.create({
  section: {
    ...shared.container,
    paddingTop: '56px',
    paddingBottom: '68px',
  },
  backButton: {
    margin: '18px 0',
    border: `1px solid ${colors.border}`,
    borderRadius: '8px',
    backgroundColor: colors.white,
    color: colors.ink,
    padding: '11px 16px',
    cursor: 'pointer',
    fontWeight: '900',
  },
  card: {
    backgroundColor: colors.white,
    border: `1px solid ${colors.border}`,
    borderRadius: '8px',
    padding: '36px',
    boxShadow: '0 18px 46px rgba(30, 30, 30, 0.06)',

    '@media (max-width: 640px)': {
      padding: '24px 18px',
    },
  },
  badge: {
    display: 'inline-flex',
    padding: '10px 14px',
    borderRadius: '8px',
    backgroundColor: colors.ink,
    color: colors.white,
    fontSize: '0.78rem',
    fontWeight: '900',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  title: {
    margin: '22px 0 18px',
    color: colors.ink,
    fontSize: '3.4rem',
    fontWeight: '900',
    lineHeight: 1.05,
    letterSpacing: 0,

    '@media (max-width: 720px)': {
      fontSize: '2.45rem',
    },

    '@media (max-width: 520px)': {
      fontSize: '1.9rem',
      lineHeight: 1.08,
    },
  },
  description: {
    maxWidth: '850px',
    margin: '0 0 32px',
    color: colors.muted,
    fontSize: '1.04rem',
    lineHeight: 1.8,
    '@media (max-width: 520px)': {
      fontSize: '0.98rem',
      lineHeight: 1.65,
    },
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '18px',
    marginBottom: '18px',

    '@media (max-width: 760px)': {
      gridTemplateColumns: '1fr',
    },
  },
  panel: {
    border: `1px solid ${colors.border}`,
    borderRadius: '8px',
    backgroundColor: colors.sand,
    padding: '22px',
  },
  panelTitle: {
    margin: '0 0 12px',
    color: colors.ink,
    fontSize: '1.45rem',
    fontWeight: '900',
    lineHeight: 1.2,
  },
  list: {
    margin: 0,
    paddingLeft: '20px',
    color: colors.muted,
    fontSize: '1rem',
    lineHeight: 1.78,
  },
  location: {
    border: `1px solid ${colors.border}`,
    borderRadius: '8px',
    backgroundColor: colors.white,
    padding: '22px',
    marginBottom: '22px',
  },
  locationText: {
    margin: 0,
    color: colors.muted,
    fontSize: '1rem',
    lineHeight: 1.7,
  },
  applyButton: {
    width: '100%',
    padding: '16px',
    border: 'none',
    borderRadius: '8px',
    backgroundColor: colors.gold,
    color: colors.ink,
    fontWeight: '900',
    fontSize: '1rem',
    cursor: 'pointer',
  },
});

export default Careers;
